import { reset } from "redux-form";

// Redux Actions
import { contactHostClose } from "../../../actions/message/contactHostModal";
import { contactHost } from "../../../actions/message/contactHost";
import showToaster from "../../../helpers/showToaster";
import { containsMaliciousForEditor } from "../../../helpers/textRestriction";

async function submit(values, dispatch) {
  const content = values.content;

  // Server-side validation for content
  if (!content || containsMaliciousForEditor(content)) {
    showToaster({
      messageId: "invalidInput",
      toasterType: "error",
      requestContent: "Your message contains invalid or unsafe content.",
    });
    return;
  }

  dispatch(contactHostClose());

  dispatch(
    contactHost(
      values.listId,
      values.host,
      content,
      values.startDate,
      values.endDate,
      values.personCapacity,
      values.hostEmail,
      values.firstName
    )
  );

  dispatch(reset("ContactHostForm"));
}

export default submit;
